import * as Scrivito from "scrivito";
import { getKeycloak } from "^/Components/Authentication/keycloak";

function LoginButton({ loginLink, title, homepage, redirectUri, className }) {
  const handleLogin = async () => {
    const url = await Scrivito.load(() =>
      Scrivito.urlFor(homepage.get("intranetLoginLink"))
    );
    getKeycloak().login({
      redirectUri: redirectUri || url,
    });
  };

  return (
    <button
      className={className || "btn btn-primary d-none d-sm-block"}
      onClick={() => handleLogin()}
    >
      {title || loginLink?.title() || "Intranet"}
    </button>
  );
}

export default Scrivito.connect(LoginButton);
